import { Controller } from "@hotwired/stimulus"

// Pilote la largeur d'une barre de progression depuis data-progress-bar-percent-value
// pour éviter `style="width:…"` inline en ERB (cf CLAUDE.md "Stylesheets / Valeurs dynamiques").
//
// Usage :
//   <div class="h-2 bg-gray-200 rounded-full overflow-hidden">
//     <div class="h-full bg-blue-500 transition-all duration-300"
//          data-controller="progress-bar"
//          data-progress-bar-percent-value="<%= percentage %>"></div>
//   </div>
export default class extends Controller {
  static values = { percent: { type: Number, default: 0 } }

  connect() {
    this.applyWidth()
  }

  percentValueChanged() {
    this.applyWidth()
  }

  applyWidth() {
    const clamped = Math.min(Math.max(this.percentValue, 0), 100)
    this.element.style.width = `${clamped}%`
  }
}
